import {
  imageAPngMimeType,
  imageBmpMimeType,
  imageGifMimeType,
  imageJpegMimeType,
  imagePJpegMimeType,
  imagePngMimeType,
  imageSvgMimeType,
  imageTiffMimeType,
  imageWebpMimeType,
} from './image/imageMimeTypes';

export const filestackSupportedMimeTypes = [
  imageAPngMimeType,
  imageBmpMimeType,
  imageGifMimeType,
  imageJpegMimeType,
  imagePJpegMimeType,
  imagePngMimeType,
  imageSvgMimeType,
  imageTiffMimeType,
  imageWebpMimeType,
  // Filestack does not support icons
  // imageIconMimeType,
];

export const filestackSupportedMimeTypesWithoutSVG = [
  imageAPngMimeType,
  imageBmpMimeType,
  imageGifMimeType,
  imageJpegMimeType,
  imagePJpegMimeType,
  imagePngMimeType,
  imageTiffMimeType,
  imageWebpMimeType,
  // Filestack does not support icons
  // imageIconMimeType,
];
